import React, { useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Modal, Button } from "react-bootstrap";
import { toast } from "react-toastify";
import api from "../../../config/URL";

function CMSEnrollAndTermsPageAdd({ onSuccess }) {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
    const userName = localStorage.getItem("userName");

  const formik = useFormik({
    initialValues: {
      description: "",
    },
    validationSchema: Yup.object({
      description: Yup.string().required("Description is required"),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const res = await api.post(
          `/createDescriptionSave?description=${encodeURIComponent(
            values.description
          )}&createdBy=${encodeURIComponent(userName)}`
        );
        toast.success(res.data.message);
        onSuccess?.();
        setShow(false);
        formik.resetForm();
      } catch (err) {
        toast.error(err.message);
      } finally {
        setLoading(false);
      }
    },
  });

  return (
    <>
      <button className="btn btn-button btn-sm" onClick={() => setShow(true)}>
        Add <i className="bx bx-plus" />
      </button>

      <Modal show={show} size="lg" onHide={() => setShow(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title className="headColor">Add Enroll And Terms</Modal.Title>
        </Modal.Header>

        <form onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <textarea
              rows="5"
              className={`form-control ${formik.touched.description && formik.errors.description
                  ? "is-invalid"
                  : ""
                }`}
              {...formik.getFieldProps("description")}
            />
            <div className="invalid-feedback">
              {formik.errors.description}
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="button"
              className="btn btn-sm btn-border bg-light text-dark"
              onClick={() => setShow(false)}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="btn btn-button btn-sm"
              disabled={loading}
            >
              {loading && (
                <span className="spinner-border spinner-border-sm me-2" />
              )}
              Submit
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

export default CMSEnrollAndTermsPageAdd;
